// extracted by mini-css-extract-plugin
export default {"hiddenDropdown":"BasicSelectMobile__hiddenDropdown___IvnQq"};